export const PANEL_IDS = {
  MONTHLY_COST: 'monthlyCost',
  DISCLAIMER: 'disclaimer',
  BREAKEVEN_CHART: 'breakevenChart',
}
